import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  selectedRetailer: null,
  listProducts: []
};

const slice = createSlice({
  name: 'restockOrder',
  initialState,
  reducers: {
    setSelectedRetailer(state, action) {
      state.selectedRetailer = action.payload;
    },
    setListProducts(state, action) {
      state.listProducts = action.payload;
    },
    addProducts(state, action) {
      const products = action.payload;
      state.listProducts = [...state.listProducts, ...products];
    },
    removeProduct(state, action) {
      const productId = action.payload;
      state.listProducts = state.listProducts.filter(
        (product) => product._id !== productId
      );
    },
    onChangeQuantity(state, action) {
      const { productId, quantity } = action.payload;
      state.listProducts = state.listProducts.map((product) => {
        if (product._id === productId) {
          return { ...product, quantity };
        }
        return product;
      });
    },
    increaseQuantity(state, action) {
      const productId = action.payload;
      state.listProducts = state.listProducts.map((product) => {
        if (product._id === productId) {
          return { ...product, quantity: product.quantity + 1 };
        }
        return product;
      });
    },
    decreaseQuantity(state, action) {
      const productId = action.payload;
      state.listProducts = state.listProducts.map((product) => {
        if (product._id === productId) {
          return { ...product, quantity: product.quantity - 1 };
        }
        return product;
      });
    },

    resetRestockOrder(state) {
      state.selectedRetailer = null;
      state.listProducts = [];
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const {
  setSelectedRetailer,
  setListProducts,
  addProducts,
  removeProduct,
  onChangeQuantity,
  increaseQuantity,
  decreaseQuantity,
  resetRestockOrder
} = slice.actions;
